import { render, staticRenderFns } from "./BvnVerified.vue?vue&type=template&id=3c49ff68&scoped=true"
import script from "./BvnVerified.vue?vue&type=script&lang=js"
export * from "./BvnVerified.vue?vue&type=script&lang=js"
import style0 from "./BvnVerified.vue?vue&type=style&index=0&id=3c49ff68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49ff68",
  null
  
)

export default component.exports